'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROD_HOST = 'https://editor-plugins.uc.cn';
var TEST_HOST = 'http://editor-plugins13.test.uae-2.uctest.local';
var BASENAME = '/editor-plugins';

var plugins = {
  richText: {
    prod: '' + PROD_HOST + BASENAME + '/richText',
    test: '' + TEST_HOST + BASENAME + '/richText',
    locale: {
      title: '文案编辑'
    }
  },
  buwangConfig: {
    prod: '' + PROD_HOST + BASENAME + '/buwangConfig',
    test: '' + TEST_HOST + BASENAME + '/buwangConfig',
    locale: {
      title: '布网配置'
    }
  }
};

exports.default = plugins;
